'use client'

import { CartItem } from 'modules/cart'

import ProfileSaleOrderProductsGroupedList from './ProfileSaleOrderProductsGroupedList'
import ProfileSaleOrdersProductCard from './ProfileSaleOrdersProductCard'

import styles from './ProfileSaleOrderDetailsProductList.module.scss'

interface ProfileSaleOrderDetailsProductListProps {
  saleOrderItems: CartItem[]
}

const ProfileSaleOrderDetailsProductList = ({
  saleOrderItems
}: ProfileSaleOrderDetailsProductListProps) => {
  return (
    <>
      <div className={styles.productsSectionTitle}>Produkty</div>
      <ProfileSaleOrderProductsGroupedList
        items={saleOrderItems}
        renderItem={(item: CartItem) => (
          <ProfileSaleOrdersProductCard
            item={item}
            key={item.id}
            href={`/${item.product.slug}`}
          />
        )}
      />
    </>
  )
}

export default ProfileSaleOrderDetailsProductList
